<template>
  <sn-modal
    v-model="showModal"
    type="decision"
    :title="title"
    data-cy="upload-csv-modal"
    primary-text="Close"
    secondary-text="Copy text"
    secondary-icon="$snCopy"
    @submit="handleClose"
    @secondarySubmit="handleCopy"
  >
    <div class="mb-10">
      {{ message }}
    </div>

    <div
      v-for="(fileName, i) in fileNames"
      :key="i"
    >
      {{ fileName }}
    </div>
  </sn-modal>
</template>

<script>

export default {
  name: 'FailedUploadDocsModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    fileNames: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleCopy () {
      const txt = this.fileNames.join('\n')
      navigator.clipboard.writeText(txt)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

</style>
